import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import {
	EnhancedCheckboxRHF,
	EnhancedCheckboxRHFWithLabel,
	EnhancedDropDownRHFWithLabel,
	LabelPosition,
	RHookFormMaskedTextFieldWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";

import { FC } from "react";
import { RHookFormMaskedTextFieldWithVerifyLabel } from "../../../RHookFormMaskedTextFieldWithVerifyLabel";

interface IClientBankInfoSetupFieldsPanel {
	isAdminUser: number;
	clientDDL: any;
	onClientBankSelectionChangeHandler: (params: any) => void;
	clientId: string | undefined;
	onVerifyBankClickedHandler: () => void;
	selectedDataRecord: any
}
export const ClientBankInfoSetupFieldsPanel: FC<
	IClientBankInfoSetupFieldsPanel
> = ({
	isAdminUser,
	clientDDL,
	onClientBankSelectionChangeHandler,
	clientId,
	onVerifyBankClickedHandler,
	selectedDataRecord
}) => {
		// RESPONSIVE
		const theme = useTheme();
		const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
		const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
		const mobileTabOrSmallLaptopScreen = isMobile || isSmallScreen;
		return (
			<Box
				sx={{
					padding: "0",
					"& .MuiTextField-root": { marginTop: 0, marginBottom: "12px" },
				}}
			>
				{(!clientId) || (mobileTabOrSmallLaptopScreen) ? (
					<EnhancedDropDownRHFWithLabel
						label={"Load client"}
						selectName="clientId"
						testId={`clientId`}
						labelPosition={LabelPosition.Top}
						items={clientDDL ?? []}
						// labelColumns={4}
						// fieldColumns={8}
						onSelectionChangeHandler={onClientBankSelectionChangeHandler}
						showEmpty
					/>
				) : (
					<></>
				)}
				<RHookFormTextFieldWithLabel
					label="Name"
					id="name"
					testId={`name`}
					labelPosition={LabelPosition.Top}
				// labelColumns={4}
				// fieldColumns={8}
				/>
				{/* <RHookFormTextFieldWithLabel
				label="Account No"
				id="accountNo"
				testId={`Account-No`}
				labelPosition={LabelPosition.Left}
				labelColumns={4}
				fieldColumns={8}
			/> */}
				{/* <RHookFormMaskedTextFieldWithLabel
				label="Account No"
				id="accountNo"
				testId={`accountNo`}
				labelPosition={LabelPosition.Top}
				placeholder={"000000000000000000"}
				inputMaskPattern={"000000000000000000"}
				// labelColumns={4}
				// fieldColumns={8}
			/> */}
				<RHookFormMaskedTextFieldWithVerifyLabel
					id="accountNo"
					testId={`accountNo`}
					placeholder={"000000000000000000"}
					inputMaskPattern={"000000000000000000"}
					label={
						<>
							<Grid> Account No&nbsp;
								<span style={{ color: theme.palette.primary.light, cursor: "pointer" }} onClick={onVerifyBankClickedHandler}>
									[Verify]
								</span>
							</Grid>
						</>
					}
				/>
				<RHookFormMaskedTextFieldWithLabel
					label="Branch Transit Number"
					id="branchTransitNumber"
					testId={`branchTransitNumber`}
					labelPosition={LabelPosition.Top}
					placeholder={"00000"}
					inputMaskPattern={"00000"}
				// labelColumns={4}
				// fieldColumns={8}
				/>
				<RHookFormMaskedTextFieldWithLabel
					label="Bank Financial No"
					id="bankFinancialNo"
					testId={`bankFinancialNo`}
					labelPosition={LabelPosition.Top}
					placeholder={"0000"}
					inputMaskPattern={"0000"}
				// labelColumns={4}
				// fieldColumns={8}
				/>

				<EnhancedCheckboxRHF
					name="primaryAccount"
					checked={false}
					testId="Primary-Account"
					// labelPosition={LabelPosition.Top}
					// labelColumns={4}
					// fieldColumns={8}
					checkboxLabel={"Primary Account"}
				/>

				{isAdminUser === 400 ? <EnhancedDropDownRHFWithLabel
					label="Status"
					selectName="status"
					testId={`Status`}
					labelPosition={LabelPosition.Top}
					items={[
						{ label: "Active", value: 100 },
						{ label: "Inactive", value: 200 },
					]}
					selectedItem={200}
				// labelColumns={4}
				// fieldColumns={8}
				/> : <span style={{ fontSize: ".875rem" }}>{selectedDataRecord && selectedDataRecord.status === 100 ? "Active" : selectedDataRecord && selectedDataRecord.status === 200 ? "Inactive" : ""}</span>}
			</Box>
		);
	};
